module.exports = __webpack_public_path__ + "img/filters_cn.32a65ab.jpg";